import * as React from "react";

import { Footer } from "../Footer";
import { Navigation } from "../Navigation/Navigation";
import navStructure from "../AuthNav/navStructure.residential.json";
import toolbarItems from "../AuthNav/toolbarItems.residential.json";

import { MyAccountHeaderBarContainer } from "../AuthNav";
import CrisisBanner from "../Banner/CrisisBanner";

export const BrowserContentProvider = ({ children }) => {
  // TODO: Error checking
  return children(window.oetal.pageData);
};

const App = ({
  nav,
  footer,
  showHeader = true,
  showFooter = true,
  authenticated = false
}) => (
  <>
    <CrisisBanner />
    {showHeader ? (
      authenticated ? (
        <MyAccountHeaderBarContainer
          logoutUrl="/content/origin-ui/en/for-home/my-account/logout.html"
          navStructure={navStructure}
          toolbarItems={toolbarItems}
          sandbox={false}
        />
      ) : (
        <Navigation
          menuItems={nav}
          activeDropdownMenuIndex={-1}
          activeTopMenuIndex={0}
        />
      )
    ) : null}
    <div id="oetal-application-root" />
    {showFooter ? <Footer {...footer} /> : null}
  </>
);

const Component = __DEV__ ? require("react-hot-loader").hot(module)(App) : App;

export { Component as App };
